import { FC, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Popconfirm } from '../common/components';
import { DataObjectFormDataType, DataObjectOutputType } from './types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './translations/DataObjectOutputTypeSelect.translations.json';
import { FormRadioGroup } from '../common/form';
import { RadioChangeEvent } from 'antd/es/radio/interface';

const { addTranslations, t } = i18nNsFactory('data-object-output-type-select');
addTranslations(translations);

type Props = {
  outputTypeCode?: string;
  onSelect: (value: string) => void;
};

export const DataObjectOutputTypeSelect: FC<Props> = ({
  outputTypeCode,
  onSelect,
}) => {
  const form = useFormContext<DataObjectFormDataType>();
  const [open, setOpen] = useState(false);
  const [outputType, setOutputType] = useState(
    outputTypeCode || DataObjectOutputType.OUTPUT
  );

  const dataObjectId = form.getValues('dataObjectId');

  const objectTypeOptions = useMemo(
    () => [
      {
        value: DataObjectOutputType.OUTPUT,
        label: t('option.OUTPUT'),
      },
      {
        value: DataObjectOutputType.INTERMEDIATE,
        label: t('option.INTERMEDIATE'),
      },
      {
        value: DataObjectOutputType.REPORT,
        label: t('option.REPORT'),
      },
    ],
    []
  );

  const showPopconfirm = (e: RadioChangeEvent) => {
    const outputTypeCode = e.target.value as DataObjectOutputType;
    setOpen(true);
    setOutputType(outputTypeCode);
  };

  const handleConfirm = () => {
    onSelect(outputType);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Popconfirm
      id="confirm-select-dataObject-outputType"
      title={t('confirmation.label')}
      description={t('confirmation.description')}
      okText={t('confirmation.confirm')}
      cancelText={t('confirmation.decline')}
      isOpen={open}
      onOpenChange={setOpen}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <FormRadioGroup
        name="outputTypeCode"
        disableValueChange={true}
        disabled={!!dataObjectId}
        onChange={showPopconfirm}
        options={objectTypeOptions}
      />
    </Popconfirm>
  );
};
